import appleSlicesImg from '../assets/appleSlices.png';
import cheesePizzaImg from '../assets/cheesePizza.png';
import crackersnCheeseImg from '../assets/crackersnCheese.png';
import darkChocolateImg from '../assets/darkChocolate.png';
import iceCreamConeImg from '../assets/iceCreamCone.png';
import nachoChipsImg from '../assets/nachoChips.png';
import pbnjSandwichImg from '../assets/pbnjSandwich.png';
import popRocksImg from '../assets/popRocks.png';
import trailMixImg from '../assets/trailMix.png';
import granolaBarImg from '../assets/granolaBar.png';
import donutImg from '../assets/donut.png';
import veggieSticksImg from '../assets/veggieSticks.png';

export const HOROSCOPE2 = [
  {
    zodiac: '♈︎ Aries',
    image: nachoChipsImg,
    title: 'Nacho Chips',
    description:
        'The Full Moon in your sign lights you up, Aries. Like nacho chips, you’re bold, zesty, and maybe a little extra salty this week. Grab a handful and channel that fiery energy into action — just don’t bite off more than you can chew in relationships.',
  },
  {
    zodiac: '♉︎ Taurus',
    image: crackersnCheeseImg,
    title: 'Crackers & Cheese',
    description:
        'As Mercury dives into Scorpio, conversations may feel heavier, Taurus. Stick to your comfort food — crackers & cheese — grounding you with familiar flavors. This week is about savoring slow connection and standing firm in love and money matters, even if Venus–Saturn throws a little cold air your way.',
  },
  {
    zodiac: '♊︎ Gemini',
    image: popRocksImg,
    title: 'Pop Rocks',
    description:
        'The Mercury–Pluto square brings sharp words and shocking truths, Gemini. You’re buzzing like Pop Rocks — surprising, loud, and impossible to ignore. Lean into the sparkle, but remember: not every thought needs to explode out of your mouth.',
  },
  {
    zodiac: '♋︎ Cancer',
    image: iceCreamConeImg,
    title: 'Ice Cream Cone',
    description:
        'The Full Moon stirs tension between career and home, Cancer. An ice cream cone reminds you to soften the moment — a sweet, melty break from the intensity. Venus–Jupiter helps you find joy in family or friends mid-week; savor it before Saturn tests your patience later on.',
  },
  {
    zodiac: '♌︎ Leo',
    image: trailMixImg,
    title: 'Trail Mix',
    description:
        'Your week is a grab-bag of highs and lows, Leo — just like trail mix. There are sweet moments (Venus sextile Jupiter), salty ones (Venus opposite Saturn), and crunchy lessons in between. Keep moving forward with courage, picking the pieces you need for the journey.',
  },
  {
    zodiac: '♍︎ Virgo',
    image: darkChocolateImg,
    title: 'Dark Chocolate',
    description:
        'Mercury in Scorpio has you analyzing everything at depth, Virgo. Dark chocolate is your match: rich, intense, slightly bitter, but oh so rewarding. This week, use your sharp insight to cut through illusions, especially in money matters.',
  },
  {
    zodiac: '♎︎ Libra',
    image: appleSlicesImg,
    title: 'Apple Slices',
    description:
        'The Full Moon highlights partnership dynamics, Libra. Apple slices remind you of balance: crisp, refreshing, and easy to share. Venus (your ruler) plays tug-of-war with Saturn, asking you to choose what’s truly nourishing and cut away what isn’t.',
  },
  {
    zodiac: '♏︎ Scorpio',
    image: pbnjSandwichImg,
    title: 'PB&J Sandwich',
    description:
        'Mercury moves into your sign, Scorpio, amplifying your voice. Like a PB&J, you’re layered — sticky, sweet, and maybe a little messy. This week’s revelations may be hard to swallow, but they’re packed with substance. Trust your instincts, but don’t overcontrol the outcome.',
  },
  {
    zodiac: '♐︎ Sagittarius',
    image: cheesePizzaImg,
    title: 'Cheese Pizza',
    description:
        'Venus–Jupiter puts you in the mood for fun, Sag, even as Saturn reminds you of limits. Cheese pizza is your vibe: simple, reliable, and always good for a crowd. Balance your urge to party with responsibility — it’s about sharing joy without burning out.',
  },
  {
    zodiac: '♑︎ Capricorn',
    image: granolaBarImg,
    title: 'Granola Bar',
    description:
        'With Venus opposing Saturn, relationships feel like work, Capricorn. A granola bar gives you practical, efficient energy — no frills, just results. Take responsibility, but don’t starve yourself of sweetness. You can carry both duty and desire in your pocket.',
  },
  {
    zodiac: '♒︎ Aquarius',
    image: veggieSticksImg,
    title: 'Veggie Sticks',
    description:
        'Pluto retrograde in your sign continues to reshape you, Aquarius. Veggie sticks — crisp, raw, refreshing — symbolize your need for clarity and clean breaks. This week, balance the intensity with honesty and a little lightness in how you nourish yourself and others.',
  },
  {
    zodiac: '♓︎ Pisces',
    image: donutImg,
    title: 'Donut',
    description:
        'Saturn retrograde in Pisces is still shaping your world, Pisces. The donut reminds you that sometimes life goes in circles — sweet, comforting, but teaching the same lessons again. Treat yourself, but pay attention to the patterns: what’s repeating, and what needs release under the waning Moon?',
  },
];